import { Button, ButtonSize, ButtonVariant, Input, Modal } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";
import { useState } from "react";

import Trans from "@/components/Trans/Trans";

interface IChangeConversationTitleModalProps {
  conversationTitle: string;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onSubmit: (newTitle: string) => Promise<void>;
  isLoading: boolean;
}

export function ChangeConversationTitleModal({ conversationTitle, isOpen, onOpenChange, onSubmit, isLoading }: IChangeConversationTitleModalProps) {
  const [newTitle, setNewTitle] = useState("");
  const { t } = useTranslation();
  const handleSubmit = () => {
    onSubmit(newTitle.trim());
  };

  const handleCancel = () => {
    onOpenChange(false);
    setNewTitle("");
  };

  return (
    <Modal
      title={t("conversation:modal.changeTitle.title")}
      description={t("conversation:modal.changeTitle.description")}
      open={isOpen}
      onOpenChange={onOpenChange}
      dismissable={!isLoading}
      className="gap-md"
    >
      <Input
        label={t("conversation:modal.changeTitle.input.label")}
        placeholder={conversationTitle}
        value={newTitle}
        onChange={setNewTitle}
        readOnly={isLoading}
        maxLength={50}
        showMaxLengthLabel={false}
      />
      <div className="flex justify-end gap-1.5">
        <Button variant={ButtonVariant.OUTLINED} size={ButtonSize.LARGE} onClick={handleCancel} disabled={isLoading}>
          <Trans i18nKey="common:cancel" />
        </Button>
        <Button onClick={handleSubmit} size={ButtonSize.LARGE} loading={isLoading} disabled={!newTitle?.trim()}>
          <Trans i18nKey="common:update" />
        </Button>
      </div>
    </Modal>
  );
}
